import {
  StyledList,
  StyledItem,
  StyledItemChoose,
  StyledItemTitle,
  StyledItemDescription,
  StyledItemDetails,
  StyledItemDetailsItem,
  StyledItemChooseItem,
  StyledItemPrice,
  StyledItemSavings,
  StyledItemButtonCta,
  StyledItemBenefits,
  StyledItemBenefitsTitle,
  StyledItemBenefitsList,
  StyledItemBenefitsListItem,
} from './Products.styles';

function AllProducts({ offers, brief, ...props }) {
  return (
    <StyledList className={props.className}>
      {offers.map((offer, i) => {
        const {
          title = '',
          subtitle = '',
          description = '',
          benefitsTitle = '',
          products = [],
          goTo = '',
        } = offer;
        const benefits = description.split('|').map((benefit) => benefit.trim()) || [];
        return (
          <StyledItem key={i} brief={brief} className={`${offer.id}`}>
            <StyledItemChoose>
              <StyledItemTitle>{title}</StyledItemTitle>
              <StyledItemDescription>{subtitle}</StyledItemDescription>
              <div>
                {products.map(({ offerSavings, price, renew }, i) => (
                  <StyledItemChooseItem key={i}>
                    <StyledItemPrice>{price}</StyledItemPrice>
                    <StyledItemSavings>{offerSavings}</StyledItemSavings>
                    <StyledItemDetails>
                      <StyledItemDetailsItem>
                        <strong>{renew}</strong>
                      </StyledItemDetailsItem>
                    </StyledItemDetails>
                  </StyledItemChooseItem>
                ))}
              </div>
              <StyledItemButtonCta onClick={goTo}>Abbonati</StyledItemButtonCta>
              {!brief && (
                <StyledItemBenefits>
                  <StyledItemBenefitsTitle>{benefitsTitle}</StyledItemBenefitsTitle>
                  <StyledItemBenefitsList>
                    {benefits.map((benefit, i) => (
                      <StyledItemBenefitsListItem key={i}>{benefit}</StyledItemBenefitsListItem>
                    ))}
                  </StyledItemBenefitsList>
                </StyledItemBenefits>
              )}
            </StyledItemChoose>
          </StyledItem>
        );
      })}
    </StyledList>
  );
}

export default AllProducts;
